import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable';
// import ThreeStepsHeadingModal from '../Modal/ThreeStepsModal/ThreeStepsHeadingModal';
// import ThreeStepsCardDesignModal from '../Modal/ThreeStepsModal/ThreeStepsCardDesignModal';
import { Grid } from '@mui/material';
// import OffersCardDesignModal from '../Modal/OffersModal/CommonCardDesignModal';

import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
// import ReferSection from './ReferralsPreview/ReferSection';
// import ReferralsHeadingModal from '../../CommonModal/ReferModal/ReferralsHeadingModal';
import ReferSection from '../StakeNowPreview/ReferralsPreview/ReferSection';
import ReferralsHeadingModal from '../Modal/Referrals/ReferralsHeadingModal';

const ReferralsSection = () => {


    const tableData = [
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

    ];
    // const tableHeadData = ['S.No', 'Title', 'Content', "Document", 'Status'];

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [editCardsData, setEditCardsData] = useState(
        [
            { card_title: 'Card 1', card_content: 'Content 1', image: null },
            { card_title: 'Card 2', card_content: 'Content 2', image: null },
            { card_title: 'Card 3', card_content: 'Content 3', image: null },
            { card_title: 'Card 4', card_content: 'Content 4', image: null }
        ]
    );

    //   ================================================

    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No', 'Title', 'Content','Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role",  "Status"]
        : ['S.No', 'Title', 'Content', 'Status']




    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getStakeNowSectionById } = useSelector(state => state?.getStakeNowSectionById);
    const { addStakeNowSectionPost } = useSelector(state => state?.addStakeNowSectionPost);

    const { updateStakeNowSection } = useSelector(
        (state) => state?.updateStakeNowSection
    );

    const { deleteStakeNowSection } = useSelector(
        (state) => state?.deleteStakeNowSection
    );




    const { getAllStakeNowSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllStakeNowSectionsWithCreatorBySectionName
    );

    const { getAllStakeNowSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllStakeNowSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllStakeNowSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addStakeNowSectionWithApproval } = useSelector(
        (state) => state?.addStakeNowSectionWithApproval
    );




    const { updateStakeNowSectionForReApproval } = useSelector(
        (state) => state?.updateStakeNowSectionForReApproval
    );


    const { approveStakeNowSection } = useSelector((state) => state?.approveStakeNowSection);
    const { rejectStakeNowSection } = useSelector((state) => state?.rejectStakeNowSection);



    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "referrals" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllStakeNowSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "referrals" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllStakeNowSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)
                console.log(responseData?.payload, "responseDataruejwhrjek")


            }
        }


        fetchData();
    }, [addStakeNowSectionPost,approveStakeNowSection, rejectStakeNowSection, addStakeNowSectionWithApproval, deleteStakeNowSection, updateStakeNowSection, updateStakeNowSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllStakeNowSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({
                  
                    title: data?.heading || '--',
                    // secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',

                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllStakeNowSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    // secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"

                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }

    }, [getAllStakeNowSectionsBySectionNameBasedOnCreator, getAllStakeNowSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")


    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteStakeNowSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETESTAKENOWSECTION(data1));
        if (responseData?.payload?.message === "Stake Now section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }

    // ==========================================================================

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable
                    tableDelete={permissions?.ContentManagement?.Home.delete}
                    // editData={editCardsData}
                    editModalName={ReferralsHeadingModal}

                    tableView={true}
                    modalVeiwName={PreviewComponent}

                    ModalPreviewComponent1={ReferSection}
                    handleTableDataDelete={handleTableDataDelete}
                    sectionNameForApproveAndReject="StakeNowSection"
                    

                    // section_name="offers"
                    tableEdit={permissions?.ContentManagement?.Home.edit}
                    dataCreate={permissions?.ContentManagement?.Home.add}
                    tableData={rowTableData} title="Referrals" tableHeadData={tableHeadData} modalName={ReferralsHeadingModal} />

            </Grid>
        </Grid>
    )
}

export default ReferralsSection